import AccountBackground from '@features/account/components/AccountBackground';
import type { ReactNode } from 'react';

type AccountProps = {
  card: ReactNode;
};

export default function Account({ card }: AccountProps) {
  return <AccountBackground>{card}</AccountBackground>;
}
